<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-12 alinmov3"></div>
      </div>
    </base-header>

    <div class="container-fluid mb-5">
      <div class="main-buttons">
        <div class="row">
          <div class="col-xl-12 mb-sm-0 mb-4">
            <div class="row">
              <div
                class="col-xl-5 col-lg-5 col-md-5 col-sm-8 col-12 mb-md-0 mb-3 align-self-center"
              >
                <b-form-group class="mb-0">
                  <b-input-group size="sm" class="input-search">
                    <b-input-group-prepend class="pt-1 pl-1">
                      <i class="flaticon-bold-magnifier"></i>
                    </b-input-group-prepend>
                    <b-form-input
                      id="filter-input"
                      v-model="simpleSearch"
                      v-on:input="applySimpleSearch"
                      type="search"
                      placeholder="Find a product within this list "
                      class="border-none"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>

              <div
                class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-sm-0 mb-3 align-self-center"
              >
                <div
                  class="input-group flackpick-group with-append-select mb-0 py-1 pl-5i select-search"
                >
                  <div class="input-group-prepend pl-2">
                    <i class="flaticon-web-placeholder-1 pl-1"></i>
                  </div>
                  <el-select
                    class="select-drop"
                    id="search"
                    name="search"
                    filterable
                    placeholder="Search by Destination"
                    @input="selectDestination"
                    v-model="destinatioId"
                    no-data-text="Search by Destination"
                    automatic-dropdown
                    clearable
                    ref="search"
                  >
                    <el-option
                      v-for="(option, index) in destinations"
                      :value="option.id"
                      :label="`${option.name} - ${option.supplierName}`"
                      :key="index"
                    >
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                          <span style>{{ option.name }}</span>
                        </div>
                        <div
                          class="col-lg-6 col-md-6 col-sm-6 col-6 text-right"
                        >
                          <span class="hide-data coin-right">
                            {{ option.supplierName }}
                          </span>
                        </div>
                      </div>
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 mb-sm-0 mb-3 align-self-center"
              >
                <div
                  class="input-group flackpick-group with-append-select mb-0 py-1 pl-5i select-search"
                >
                  <div class="input-group-prepend pl-2">
                    <i class="flaticon-web-tag pl-1"></i>
                  </div>
                  <el-select
                    class="select-drop"
                    id="search"
                    name="search"
                    filterable
                    placeholder="Search by Category"
                    @input="selectCategory"
                    v-model="categoryId"
                    no-data-text="Search by Category"
                    ref="search"
                  >
                    <el-option :value="'ALL'" :label="'All Categories'">
                    </el-option>
                    <el-option
                      v-for="(option, index) in categories"
                      :value="option.id"
                      :label="`${option.name}`"
                      :key="index"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          ></div>

          <div
            class="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-3 text-right"
          >
            <div class="col-filter d-inline-flex mr-2">
              <b-form-group v-slot="{ ariaDescribedbyview }">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="viewProducts"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewProducts"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card-h"
                    ><i class="flaticon-grid" title="View Card horizontal"></i
                  ></b-form-radio>

                  <b-form-radio value="card-v"
                    ><i class="flaticon-menu" title="View Card vertical"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>
            <div class="d-inline-block mr-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button
                    slot="title"
                    type="none"
                    class="pl-0 pr-0 icon-only"
                  >
                    <i class="flaticon-down-2 mr-0 "></i>
                  </base-button>

                  <div class="dropdown-item" @click="downloadCSV(allProducts)">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>

            <div class="d-inline-block mr-2">
              <el-tooltip content="Import" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="importCSV"
                >
                  <i class="flaticon-up-2 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>

              <input
                type="file"
                ref="fileInput"
                class="d-none"
                @change="bulkUpdateCommissions"
                accept=".csv"
              />
            </div>
            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div class="border-top pt-1">
          <fade-transition
            :duration="300"
            mode="out-in"
            v-if="experiences.length === 0 && requestStatus === 'RESOLVED'"
          >
            <base-alert type="danger" class="mb-4 info-min text-center">
              <i class="flaticon-warning mr-1"></i>
              <strong>Not Found!</strong> There are no experiences available for
              your search. Try searching other destinations or categories
            </base-alert>
          </fade-transition>

          <fade-transition group :duration="300" mode="out-in" v-else>
            <div v-if="viewProducts === 'table'" :key="'table'">
              <b-table
                hover
                :items="experiences"
                :fields="fields"
                sort-by.sync="category"
                sort-asc.sync="true"
                selectable
                @row-selected="onRowSelected"
                select-mode="multi"
                ref="selectableTable"
                sort-icon-left
                responsive
                show-empty
                empty-filtered-text="There are no records matching your request"
                empty-text="There are no records to show"
                :table-class="getTableClass(experiences)"
              >
                <template #cell(productCode)="data">
                  <router-link
                    class="capitalize hide-data"
                    :to="`/experiences/ventrata/${data.item._id}`"
                  >
                    {{ data.item.code }}
                  </router-link>
                </template>

                <template #cell(title)="data">
                  <div class="d-flex align-items-center min-img-product">
                    <LazyImage
                      :src="data.item.images[0] || noImage"
                      imgClasses="img-experience-min"
                      beforeClasses="d-inline-flex"
                    />
                    <router-link
                      :to="
                        `/experiences/ventrata/${data.item._id}?providerId=${data.item.providerId}`
                      "
                      class="title multiline-3 d-inline-flex"
                    >
                      {{ data.item.name }}
                    </router-link>
                  </div>
                </template>

                <template #cell(category)="data">
                  <span
                    class="hide-data-multiple"
                    v-if="data.item.categories.length > 0"
                  >
                    {{ getCategories(data.item.categories) }}
                  </span>
                  <span v-else>-</span>
                </template>

                <template #cell(destination)="data">
                  <span class="hide-data">{{
                    data.item.destination.country.name
                  }}</span>
                  <span class="hide-data">{{ data.item.location }}</span>
                </template>

                <template #cell(supplier)="data">
                  <span class="hide-data">{{ data.item.supplier }}</span>
                </template>

                <template #cell(basePrice)="data">
                  <span class="d-block f14">From</span>
                  <span
                    >{{ data.item.currency.symbol }}
                    {{ data.item.pricing ? data.item.pricing.amount : 0 }}
                    {{ data.item.currency.code }}</span
                  >
                </template>

                <template #cell(actions)="data">
                  <div
                    class="button-book d-inline-block px-3"
                    @click="
                      $router.push(
                        `/reservations/new?productId=${data.item._id}&providerId=${data.item.providerId}`
                      )
                    "
                  >
                    <span>Book Now</span>
                  </div>
                </template>
              </b-table>
            </div>

            <div v-else-if="viewProducts === 'card-h'" :key="'card-h'">
              <div class="col-lg-12">
                <div class="row justify-content-center">
                  <div
                    class="col-xl-9 col-lg-11 col-md-11 col-sm-12 col-12 mb-3"
                    v-for="(product, index) in experiences"
                    :key="index"
                  >
                    <cardHorizontal
                      :product="product"
                      :index="index"
                      :excerpt="true"
                      size="lg"
                      price
                      source="VENTRATA"
                    ></cardHorizontal>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="viewProducts === 'card-v'" :key="'card-v'">
              <div class="col-lg-12 p-0">
                <div class="row justify-content-center">
                  <div
                    v-for="(product, index) in experiences"
                    :key="index"
                    class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-3 box-flex"
                  >
                    <cardVertical
                      :product="product"
                      :index="index"
                      :excerpt="true"
                      price
                      size="lg"
                      source="VENTRATA"
                    ></cardVertical>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 pt-3 text-center" :key="'button'">
              <base-button
                type="primary"
                class="min-button"
                v-if="seeMoreButton"
                @click="seeMoreProducts()"
                >Show More</base-button
              >
            </div>
          </fade-transition>
        </div>
      </div>
    </div>
    <LightBox
      v-if="showLightbox"
      :media="imagesExperiences"
      :showLightBox="showLightbox"
    />
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  DocumentsAPI,
  ProductsAPI,
  VentrataAPI
} from "../../../../../core/api";
import Swal from "sweetalert2";
import { BCarousel } from "bootstrap-vue";
import cardVertical from "../../../components/cards/CardVertical.vue";
import cardHorizontal from "../../../components/cards/CardHorizontal.vue";
import LightBox from "vue-image-lightbox";
import "vue-image-lightbox/dist/vue-image-lightbox.min.css";
import draggable from "vuedraggable";
import WSelect from "@/components/Select";
import { FadeTransition } from "vue2-transitions";
import { goBack } from "../../../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "ExperiencesVentrata",
  components: {
    "b-carousel": BCarousel,
    cardVertical,
    cardHorizontal,
    LightBox,
    draggable,
    WSelect: WSelect,
    FadeTransition
  },

  data() {
    return {
      selectedRows: [],
      currentPage: 1,
      options: [],
      cardview: true,
      selected: [],
      limit: 12,
      simpleSearch: "",
      timerSimpleSearch: null,
      query: "",
      viewProducts: "table",
      guides: [],
      loader: false,
      visibleSideBar: false,
      imagesExperiences: [],
      showLightbox: false,
      fields: [
        {
          key: "title",
          label: "Title",
          sortable: true,
          thStyle: { minWidth: "400px" },
          class: "text-left",
          settings: {
            drag: true,
            disabled: true,
            default: true
          }
        },
        {
          key: "category",
          label: "Category",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6",
          settings: {
            drag: true,
            disabled: false,
            default: true
          }
        },
        {
          key: "destination",
          label: "Destination",
          sortable: true,
          thStyle: { minWidth: "190px" },
          class: "text-left",
          settings: {
            drag: true,
            disabled: false,
            default: true
          }
        },
        {
          key: "supplier",
          label: "Supplier",
          sortable: true,
          thStyle: { minWidth: "190px" },
          class: "text-left",
          settings: {
            drag: true,
            disabled: false,
            default: true
          }
        },
        {
          key: "basePrice",
          label: "Price",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "alinmov7",
          settings: {
            drag: true,
            disabled: false,
            default: true
          }
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "120px" },
          stickyColumn: false,
          settings: {
            drag: false,
            disabled: true,
            default: true
          }
        }
      ],
      suppliers: [],
      products: [],
      experiences: [],
      destinations: [],
      categories: [],
      noImage: require("rhomtrip_assets/src/img/no-image-available.png"),
      categoryId: "ALL",
      loading: false,
      destinatioId: "",
      productIterator: null,
      seeMoreButton: true,
      allProducts: [],
      providerId: null,
      requestStatus: "INIT"
    };
  },
  watch: {},
  async created() {
    this.setItemsBread([
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Ventrata Experiences ",
        active: true
      }
    ]);
    let action = "INIT";
    this.suppliers = await this.getSuppliers();
    this.destinations = this.getDestinations(this.suppliers);
    this.categories = this.getCategoriesOptions(this.destinations);
    if (this.externalProductSearchCriteria.status) {
      this.currentPage = this.externalProductSearchCriteria.currentPage;
      this.categoryId = this.externalProductSearchCriteria.categoryId;
      this.destinationId = this.externalProductSearchCriteria.destinationId;
      this.simpleSearch = this.externalProductSearchCriteria.simpleSearch;
      this.products = this.externalProductSearchCriteria.products;
      this.experiences = this.simpleSearch
        ? this.filterProductBySearchCriteria(this.products, this.simpleSearch)
        : this.products;
      action = "FILTER";
    }
    await this.getProducts(this.destinatioId, this.categoryId, action);
  },

  methods: {
    goToPreviousPage() {
      goBack(this);
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    changeViewProducts(value) {
      this.viewProducts = value;
    },
    isInProductModule(modules = []) {
      if (!modules.includes("experiences")) {
        this.setExternalProductSearchCriteria({
          currentPage: 1,
          categoryId: "",
          destinationId: "",
          simpleSearch: "",
          limit: 12,
          products: [],
          status: false
        });
      }
    },
    getTableClass(items = []) {
      return items.length < 7 ? "b-table-separator" : "";
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "EXPERIENCES");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    getDestinations(suppliers = []) {
      return suppliers
        .map(supplier => {
          return supplier.destinations.map(destination => {
            destination.supplierId = supplier.id;
            destination.supplierName = supplier.name;
            return destination;
          });
        })
        .flat()
        .map(destination => {
          return {
            id: destination.id,
            name: destination.name,
            supplierId: destination.supplierId,
            supplierName: destination.supplierName,
            categories: destination.categories
          };
        });
    },
    getCategoriesOptions(destinations = []) {
      return destinations
        .map(destination => {
          return destination.categories.map(category => {
            category.supplierId = destination.supplierId;
            category.supplierName = destination.supplierName;
            category.destinatioId = destination.id;
            category.destinationName = destination.name;
            return category;
          });
        })
        .flat();
    },
    async getSuppliers() {
      try {
        let { data } = await VentrataAPI.getSuppliers();
        return data;
      } catch (error) {
        return [];
      }
    },
    mapProduct(products = []) {
      try {
        return products.map(product => {
          return this.populateProduct(product);
        });
      } catch (error) {
        return [];
      }
    },
    populateProduct(product) {
      return {
        _id: product.id,
        code: "",
        images: this.getProductImages(product),
        name: product.title || product.internalName,
        short_description: product.shortDescription
          ? product.shortDescription
          : "",
        description: product.description ? product.description : "",
        duration: this.getDurationByOption(product.options),
        pricing: this.getPricingFromByProduct(product),
        location: product.location,
        destination: {
          country: {
            name: ""
          },
          city: product.destination.name
        },
        currency: {
          code: product.defaultCurrency,
          symbol: this.getCurrencySymbol(product.defaultCurrency)
        },
        categories: product.categories,
        supplier: product.destination.contact.name,
        providerId: product.providerId
      };
    },
    getDurationByOption(options = []) {
      let [option] = options;
      return option ? option.duration : "";
    },
    getPricingFromByProduct(product) {
      if (product.pricingPer === "UNIT") {
        let [option] = product.options;
        return this.getPricingFromByUnits(
          option.units,
          product.defaultCurrency
        );
      } else {
        return {
          amount: 0
        };
      }
    },
    getPricingFromByUnits(units = [], defaultCurrency) {
      let [unit] = units;
      return unit ? this.getPricingFromByUnit(unit, defaultCurrency) : null;
    },
    getPricingFromByUnit(unit, defaultCurrency) {
      try {
        if (unit) {
          let pricing = unit.pricingFrom.find(
            pricing => pricing.currency === defaultCurrency
          );
          return pricing
            ? {
                amount: pricing.retail / 10 ** pricing.currencyPrecision
              }
            : null;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    getCurrencySymbol(currencyCode) {
      if (currencyCode === "USD") {
        return "$";
      } else if (currencyCode === "EUR") {
        return "€";
      } else if (currencyCode === "GBP") {
        return "£";
      }
    },
    getProductImages(product) {
      if (product.coverImageUrl) {
        return [product.coverImageUrl];
      } else if (product.galleryImages.length) {
        return product.galleryImages.map(gallery => gallery.url);
      } else if (product.bannerImageUrl) {
        return [product.bannerImageUrl];
      } else if (product.bannerImages.length) {
        return product.bannerImages.map(banner => banner.url);
      } else {
        return [require("rhomtrip_assets/src/img/no-image-available.png")];
      }
    },
    applySimpleSearch(value) {
      this.setSearchCriteria();
      clearTimeout(this.timerSimpleSearch);
      this.timerSimpleSearch = setTimeout(async () => {
        if (value) {
          let searchTerm = value.toLowerCase();
          this.experiences = this.filterProductBySearchCriteria(
            this.products,
            searchTerm
          );
        } else {
          this.experiences = this.products;
        }
      }, 800);
    },
    filterProductBySearchCriteria(products = [], search) {
      let searchTerm = search.toLowerCase();
      return products.filter(product => {
        return (
          product.name.toLowerCase().includes(searchTerm) ||
          product.short_description.toLowerCase().includes(searchTerm) ||
          product.description.toLowerCase().includes(searchTerm)
        );
      });
    },
    getCategories(categories = []) {
      return categories.map(category => category.name).join(" | ");
    },
    setSearchCriteria() {
      if (
        this.destinationId ||
        this.categoryId ||
        this.currentPage > 1 ||
        this.simpleSearch ||
        this.limit
      ) {
        this.setExternalProductSearchCriteria({
          currentPage: this.currentPage,
          categoryId: this.categoryId,
          destinationId: this.destinationId,
          simpleSearch: this.simpleSearch,
          limit: this.limit,
          products: this.products,
          status: true
        });
      }
    },
    async getProducts(destinationId, categoryId, action = "INIT") {
      let limit = action !== "INIT" ? this.limit * this.currentPage : 12;
      this.setLoad(true);
      this.requestStatus = "PENDING";
      this.allProducts = this.mapProduct(
        await this.getExternalProducts(
          destinationId,
          categoryId,
          action,
          this.providerId
        )
      );
      this.productIterator = this.chunkIterator(this.allProducts, limit);
      let products = this.productIterator.next().value || [];
      this.products = [];
      this.products.push(...products);

      this.experiences = this.simpleSearch
        ? this.filterProductBySearchCriteria(this.products, this.simpleSearch)
        : this.products;

      this.seeMoreButton = this.allProducts.length !== this.products.length;
      this.requestStatus = "RESOLVED";
      this.setLoad(false);
      this.setSearchCriteria();
    },
    async seeMoreProducts() {
      let products = this.productIterator.next().value || [];
      this.currentPage += 1;
      this.products.push(...products);
      this.experiences = this.simpleSearch
        ? this.filterProductBySearchCriteria(this.products, this.simpleSearch)
        : this.products;

      this.seeMoreButton = this.allProducts.length !== this.products.length;
      this.setSearchCriteria();
    },
    async selectCategory(categoryId) {
      this.providerId = this.getProviderByCategoryId(
        categoryId,
        this.categories
      );
      await this.getProducts(this.destinatioId, categoryId, "FILTER");
    },
    async selectDestination(destinationId) {
      this.categoryId = "ALL";
      this.currentPage = 1;
      this.providerId = this.getProviderByDestinationId(
        destinationId,
        this.destinations
      );
      if (destinationId) {
        let destinations = this.destinations.filter(
          destination => destination.id === destinationId
        );
        this.categories = this.getCategoriesOptions(destinations);
        await this.getProducts(destinationId, this.categoryId, "FILTER");
      } else {
        this.categories = this.getCategoriesOptions(this.destinations);
        await this.getProducts(destinationId, this.categoryId);
      }
    },
    *chunkIterator(products = [], initialSize = 12) {
      let index = 0;
      let size = initialSize;
      while (index < products.length) {
        let chunk = products.slice(index, index + size);
        let newSize = yield chunk;
        if (newSize !== undefined) size = newSize;
        index += chunk.length;
      }
    },
    async getOtaProducts(queries, providerId) {
      try {
        let { data } = await VentrataAPI.getProducts(queries, providerId);
        if (data) {
          return data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    async getExternalProducts(destinationId, categoryId, action, providerId) {
      if (action === "INIT") {
        return this.getOtaProducts({}, providerId);
      } else {
        let queries = {};
        if (categoryId && categoryId !== "ALL") {
          queries.categoryId = categoryId;
        }
        if (destinationId) {
          queries.destinationId = destinationId;
        }
        return this.getOtaProducts(queries, providerId);
      }
    },
    async downloadCSV(experiences = []) {
      try {
        this.setLoad(true);
        const data = [
          [
            "Uuid",
            "Title",
            "Duration",
            "Destination",
            "Supplier",
            "Commission"
          ],
          ...experiences.map(experience => {
            return [
              experience._id,
              `"${(experience.name || "").replace(/"/g, '""')}"`,
              `"${(experience.duration || "").replace(/"/g, '""')}"`,
              `"${(experience.location || "").replace(/"/g, '""')}"`,
              `"${(experience.supplier || "").replace(/"/g, '""')}"`,
              0
            ];
          })
        ];
        const csvContent = data.map(row => row.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Experiences(Ventrata).csv"; // Nombre del archivo
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
        this.setLoad(false);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async importCSV() {
      let { value } = await Swal.fire({
        title: "Import Experiences Data",
        html:
          "You are about to import a file that may cause severe changes to the data. <br><br><strong>Are you sure you want to upload the file? </strong><br><br>Make sure it is the file with the correct format and that all data is verified. <br><br><strong class='text-danger'>This action can't be undone.</strong>",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.$refs.fileInput.click();
      }
    },
    async bulkUpdateCommissions(event) {
      try {
        const [file] = event.target.files;
        if (file) {
          let formData = new FormData();
          formData.append("file", file);
          this.setLoad(true);
          let { data } = await ProductsAPI.bulkUpdateCommissions(
            formData,
            this.sesion.token
          );
          this.setLoad(false);
          this.$refs.fileInput.value = null;
          if (data.status) {
            this.$notify({
              type: "success",
              title: "Success!",
              message: "The file has been successfully imported.",
              icon: "flaticon-check-3"
            });
          } else {
            let { message } = data.error[0]
              ? data.error[0]
              : { message: "The data was not download. Please try again" };
            this.$notify({
              type: "warning",
              title: "Warning!",
              message: message,
              icon: "flaticon-remove"
            });
          }
        } else {
          event.preventDefault();
        }
      } catch (error) {
        this.$refs.fileInput.value = null;
        this.setLoad(false);
        this.$notify({
          type: "warning",
          title: "Warning!",
          message:
            "There is an error in the imported file. Please check the data and try again",
          icon: "flaticon-warning-1"
        });
      }
    },
    getProviderByDestinationId(destinationId, destinations = []) {
      let destination = destinations.find(
        destination => destination.id === destinationId
      );
      return destination ? destination.supplierId : null;
    },
    getProviderByCategoryId(categoryId, categories = []) {
      let category = categories.find(category => category.id === categoryId);
      return category ? category.supplierId : null;
    },
    ...mapMutations([
      "setLoad",
      "setItemsBread",
      "setExternalProductSearchCriteria"
    ]),
    ...mapActions(["getLimit"])
  },
  computed: {
    ...mapGetters([
      "sesion",
      "paginationLimit",
      "externalProductSearchCriteria",
      "settings"
    ])
  },
  beforeRouteLeave(to, from, next) {
    this.isInProductModule(to.meta.modules);
    next();
  }
};
</script>
